<template>
  <div class="accordion-item">
    <div class="accordion-item-title">
      <span @click="toggleExpandedSections">{{ title }}</span>
      <Button @click="toggleExpandedSections">
        <MdIcon :name="isExpanded ? 'chevron-up' : 'chevron-down'" />
      </Button>
    </div>
    <slot v-if="isExpanded" />
  </div>
</template>

<script>
import Button from '@/components/common/Button.vue';
import MdIcon from '@/components/common/MdIcon.vue';
export default {
  name: 'AccordionItem',
  components: {
    Button,
    MdIcon
  },
  props: {
    isExpanded: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleExpandedSections() {
      this.$emit('toggle');
    }
  }

}
</script>
<style lang="scss" scoped>
.accordion-item {
  margin-bottom: 10px;

  .accordion-item-title {
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .accordion-item-subtitle {
    display: block;
    margin-bottom: 10px;
  }
}
</style>